import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
const factoryPoiStyle = 
new Style({
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'data/icons/24px/factory.png',
    color:'#3A86FF',
    scale: 0.7
  }),
});

export const poiFactoryLayer = new VectorLayer({
source: new VectorSource({
  url: 'data/india/UP/point_of_interest_SHPIND.json',
  format: new TopoJSON({
    layers: ['SHPIND'],
  }),
  overlaps: true,
}),
//minZoom: POI_MIN_ZOOM_LEVEL,
style: factoryPoiStyle,
visible: true,
zIndex : 2
});
